<template>
  <div class="home-container">
    <CategorySlider :categories="subCategories" />
    <div class="main-content-container">
      <router-view />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CategorySlider from "@/components/CategorySlider.vue";
import categories_nl_json from "../../public/items.json";
import categories_en_json from "../../public/items_en.json";
import categories_tr_json from "../../public/items_tr.json";

export default {
  name: "Home",
  components: {
    CategorySlider,
  },
  data() {
    return {
      items_files: {
        nl: categories_nl_json,
        en: categories_en_json,
        tr: categories_tr_json,
      },
      warning: [
        {
          nl: "Beste klant,",
          en: "Dear guest,",
          tr: "Sayın müşterimiz,",
        },
        {
          nl: "Gegrilde gerechten worden geserveerd van 17:00 tot 21:00 uur.",
          en: "Hot dishes are served from 17:00 to 21:00.",
          tr: "Izgara çeşitlerimiz saat 17:00'dan 21:00'a kadar servis edilmektedir.",
        },
      ],
    };
  },

  computed: {
    subCategories() {
      // A list of tuples, [[routeToCategory, category], ...]]
      const categories = this.items_files[this.$route.query.lang];
      const subCategories = [];
      categories.forEach((category) => {
        if (category.subCategories) {
          category.subCategories.forEach((subCategory) => {
            subCategories.push([category.id, subCategory]);
          });
        }
      });
      return subCategories;
    },
  },
};
</script>

<style>
.home-container {
  margin-top: 6rem;
  margin-bottom: 2rem;
}

.main-content-container {
  margin-top: 1rem;
  background-color: #354b7c;
  padding-top: 2rem;
  padding-bottom: 1rem;
}
</style>
